<div class="qr-page" [class.qr-page--mobile]="rwdService.isSmallDevice">
  <div class="qr-page__card">
    <ng-container *ngIf="isQrDataLoading; else qrPageContent">
      <div class="qr-page__loading">
        <mat-spinner diameter="44"></mat-spinner>
        <div>
          <div class="qr-page__loading-title">{{ 'estate.qrPublicLoadingTitle' | loc }}</div>
          <p>{{ 'estate.qrPublicLoadingDesc' | loc }}</p>
        </div>
      </div>
    </ng-container>

    <ng-template #qrPageContent>
      <ng-container *ngIf="qrData; else invalidQr">
      <div class="qr-page__hero">
        <div class="qr-page__hero-icon">
          <mat-icon>{{ icon }}</mat-icon>
        </div>
        <div class="qr-page__hero-content">
          <div class="qr-page__hero-head">
            <h1>{{ 'estate.qrPublicTitle' | loc }}</h1>
            <app-language-select></app-language-select>
          </div>
          <p>{{ 'estate.qrPublicDesc' | loc }}</p>
        </div>
      </div>

      <ng-container *ngIf="!isSubmitted; else submitSuccess">
        <form class="qr-page__form" [formGroup]="reportForm" (ngSubmit)="submitReport()">
          <div class="qr-page__section">
            <div class="qr-page__section-head">
              <div>
                <h3 class="qr-page__section-subtitle">{{ 'images.label' | locCap }}</h3>
                <p class="qr-page__section-hint">
                  {{ 'estate.qrPublicPhotosHint' | locRep: { $max: maxPhotoCount } }}
                </p>
              </div>
              <div class="qr-page__photo-counter">{{ photos.length }} / {{ maxPhotoCount }}</div>
            </div>

            <input
              #photoInput
              type="file"
              class="qr-page__photo-input"
              [accept]="acceptedPhotoExtensions"
              multiple
              (change)="onPhotosSelected($event)"
            />

            <button type="button" class="qr-page__upload-button" (click)="openPhotoPicker()">
              <mat-icon>add_a_photo</mat-icon>
              <span>{{ 'button.addPhoto' | locCap }}</span>
            </button>

            <div class="qr-page__photos" *ngIf="photos.length">
              <app-image-preview-item
                *ngFor="let photo of photos; let i = index"
                [rawData]="photo.previewDataUrl"
                [size]="photo.file.size"
                [removeButton]="true"
                (onRemove)="removePhoto(i)"
              ></app-image-preview-item>
            </div>

            <div class="qr-page__error" *ngIf="photoError">{{ photoError }}</div>
          </div>

          <div class="qr-page__section">
            <app-text-input
              formControlName="description"
              labelKey="estate.qrPublicDescriptionLabel"
              placeholderKey="estate.qrPublicDescriptionPlaceholder"
              type="textarea"
              [rows]="5"
              [max]="'1000'"
              [required]="true"
            ></app-text-input>

            <div class="qr-page__speech">
              <button
                *ngIf="isSpeechRecognitionSupported; else speechRecognitionUnavailable"
                type="button"
                mat-stroked-button
                color="primary"
                class="qr-page__speech-button"
                [disabled]="isSubmitting"
                (click)="toggleDescriptionSpeechRecognition()"
              >
                <mat-icon>{{ isListeningDescription ? 'stop_circle' : 'keyboard_voice' }}</mat-icon>
                <span>{{ (isListeningDescription ? 'estate.qrPublicSpeechStop' : 'estate.qrPublicSpeechStart') | loc }}</span>
              </button>

              <ng-template #speechRecognitionUnavailable>
                <p class="qr-page__speech-status">
                  {{ 'estate.qrPublicSpeechUnavailable' | loc }}
                </p>
              </ng-template>

              <p
                class="qr-page__speech-status"
                [class.qr-page__speech-status--active]="isListeningDescription"
                *ngIf="isSpeechRecognitionSupported"
              >
                {{ speechStatusKey | loc }}
              </p>

              <div class="qr-page__error" *ngIf="speechRecognitionError">{{ speechRecognitionError }}</div>
            </div>
          </div>

          <div class="qr-page__section">
            <h3 class="qr-page__section-subtitle">{{ 'estate.qrPublicContactTitle' | loc }}</h3>
            <div class="qr-page__grid qr-page__grid--contact">
              <app-text-input
                formControlName="firstName"
                labelKey="user.name"
                placeholderKey="estate.qrPublicFirstNamePlaceholder"
              ></app-text-input>
              <app-text-input
                formControlName="lastName"
                labelKey="user.surname"
                placeholderKey="estate.qrPublicLastNamePlaceholder"
              ></app-text-input>
              <app-text-input
                formControlName="email"
                labelKey="estate.qrPublicEmailLabel"
                placeholderKey="estate.qrPublicEmailPlaceholder"
                type="email"
                [required]="true"
              ></app-text-input>
              <app-text-input
                formControlName="phone"
                labelKey="estate.qrPublicPhoneLabel"
                placeholderKey="estate.qrPublicPhonePlaceholder"
              ></app-text-input>
            </div>
          </div>

          <div class="qr-page__section qr-page__section--compact">
            <div class="qr-page__checkbox">
              <mat-checkbox class="qr-page__checkbox-control" color="primary" formControlName="notifyUpdates">
                <span class="qr-page__checkbox-text">
                  {{ 'estate.qrPublicNotifyUpdates' | loc }}
                </span>
              </mat-checkbox>
            </div>

            <div class="qr-page__checkbox qr-page__checkbox--required">
              <mat-checkbox class="qr-page__checkbox-control" color="primary" formControlName="privacyConsent">
                <span class="qr-page__checkbox-text">
                  {{ 'estate.qrPublicPrivacyConsent' | loc }}
                </span>
              </mat-checkbox>
            </div>
            <a
              class="qr-page__privacy-link"
              href="https://fliko.pl/polityka-prywatnosci/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ 'navigation.politics' | loc }}
            </a>
            <div class="qr-page__error" *ngIf="isControlInvalid('privacyConsent')">
              {{ 'estate.qrPublicPrivacyConsentRequired' | loc }}
            </div>
          </div>

          <div class="qr-page__actions">
            <button type="submit" mat-flat-button color="primary" class="qr-page__submit" [disabled]="isSubmitting">
              {{ (isSubmitting ? 'estate.qrPublicSubmitting' : 'button.sendRequest') | loc }}
            </button>
          </div>

          <div class="qr-page__error" *ngIf="submitError">{{ submitError }}</div>
        </form>
      </ng-container>

      <ng-template #submitSuccess>
        <div class="qr-page__success">
          <div class="qr-page__hero-icon qr-page__hero-icon--success">
            <mat-icon>check_circle_outline</mat-icon>
          </div>

          <div>
            <h2 class="qr-page__section-title qr-page__section-title--success">{{ 'estate.qrPublicSuccessTitle' | loc }}</h2>
            <p class="qr-page__success-id" *ngIf="submittedRequestId">
              {{ 'estate.qrPublicSuccessId' | loc }} {{ submittedRequestId }}
            </p>
            <p class="qr-page__success-text" *ngIf="confirmationEmailQueued; else successWithoutMail">
              {{ 'estate.qrPublicSuccessMail' | loc }}
            </p>
            <ng-template #successWithoutMail>
              <p class="qr-page__success-text">{{ 'estate.qrPublicSuccessNoMail' | loc }}</p>
            </ng-template>

            <div class="qr-page__track" *ngIf="submittedPublicStatusUrl && publicStatusCode">
              <div class="qr-page__track-label">{{ 'estate.qrPublicStatusTitle' | loc }}</div>
              <p class="qr-page__track-desc">{{ 'estate.qrPublicStatusDesc' | loc }}</p>
              <div class="qr-page__track-code">
                <span>{{ 'estate.qrPublicStatusCode' | loc }}:</span>
                <strong>{{ publicStatusCode }}</strong>
              </div>
              <a mat-stroked-button color="primary" class="qr-page__track-link" [href]="submittedPublicStatusUrl">
                {{ 'estate.qrPublicStatusOpen' | loc }}
              </a>
            </div>
          </div>
        </div>
      </ng-template>

      <div class="qr-page__property" *ngIf="propertyDetailsSummary">
        <div class="qr-page__property-label">{{ 'estate.qrPublicPropertyData' | loc }}</div>
        <p class="qr-page__property-text">{{ propertyDetailsSummary }}</p>
      </div>
      </ng-container>
    </ng-template>

    <ng-template #invalidQr>
      <div class="qr-page__hero qr-page__hero--invalid">
        <div class="qr-page__hero-icon qr-page__hero-icon--invalid">
          <mat-icon>error_outline</mat-icon>
        </div>
        <div class="qr-page__hero-content">
          <div class="qr-page__hero-head">
            <h1>{{ 'estate.qrPublicInvalidTitle' | loc }}</h1>
            <app-language-select></app-language-select>
          </div>
          <p>{{ 'estate.qrPublicInvalidDesc' | loc }}</p>
        </div>
      </div>
    </ng-template>

    <div class="qr-page__footer">
      <div class="qr-page__brand" aria-hidden="true">
        <app-logo-svg color="primary"></app-logo-svg>
      </div>
      <div class="qr-page__footer-text">
        {{ 'estate.qrFooterGeneratedWith' | loc }}
        <a href="https://fliko.pl/" target="_blank" rel="noopener noreferrer">Fliko</a>
      </div>
    </div>
  </div>
</div>
